import React from "react";

const sponsorStyle = {
  width: 120,
  height: "auto",
};

const lastElement = () => {
  const myUrl = window.location.href;
  const url_array = myUrl.split("/");
  return url_array[url_array.length - 1];
};

const changeColor = (e) => {
  e.target.style.color = "#fcbe04";
};

const restoreColor = (e) => {
  e.target.style.color = "#007bff";
};

const removeOnIndex = () => {
  if (lastElement() === "") {
    return { marginTop: -90 };
  } else {
    return { marginTop: 0 };
  }
};

class Extremeevent extends React.Component {
  render() {
    return (
      <section id="testimonial" className="testimonial" style={removeOnIndex()}>
        <div className="testimonial-decor">
          <div className="testi-circle1">
            <img src="assets/images/Testimonial2.png" alt="" />
          </div>
          <div className="testi-circle2">
            <img src="assets/images/Testimonial1.png" alt="" />
          </div>
        </div>
        <div className="container" style={{ marginTop: 200 }}>
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="testimonial-carousel">
                <div className="testimonial-item">
                  <div className="testimonial-block">
                    <div className="testimonial-avtar">
                      <img
                        src="assets/images/xtreme_sports_expo/xtreme_sports_logo.png"
                        alt="logo-img"
                        className="caption-img"
                      />
                    </div>
                    <div
                      className="testimonial-text"
                      //style={{ marginRight: -120, marginLeft: -120 }}
                    >
                      {lastElement() === "" ? (
                        <div class="title">
                          <h2>
                            <span>
                              ΔΙΟΡΓΑΝΩΣΗ ΕΚΘΕΣΕΩΝ, <br />
                              ΣΥΝΕΔΡΙΩΝ & EVENTS
                            </span>
                          </h2>
                        </div>
                      ) : (
                        <h3>ΕΚΘΕΣΕΙΣ – EVENT</h3>
                      )}
                      <br />
                      <p>
                        Για πρώτη φορά στην Ελλάδα η Διεθνής Έκθεση Extreme
                        Sports
                      </p>
                      <p>
                        <b>Η EXTREME SPORTS EXPO Greece 2020</b> είναι μια 100%
                        στοχευμένη έκθεση για επαγγελματίες και λάτρεις των
                        extreme sports.
                      </p>
                      <p>
                        Διοργανώνεται για πρώτη φορά στην Ελλάδα, με
                        αποκλειστικό σκοπό την συνάντηση όλων των επαγγελματιών
                        της δράσης και προμηθευτών εξοπλισμού.
                      </p>
                      <p>
                        Ο απαρέγκλιτος στόχος της EXTREME SPORTS EXPO Greece
                        2020 που επικεντρώνεται να αποτελέσει κορυφαίο εκθεσιακό
                        γεγονός της Ευρώπης, είναι:
                      </p>
                      <p>
                        <ol>
                          <li>
                            Η γνωριμία – ενημέρωση – ψυχαγωγία των επισκεπτών με
                            τις κορυφαίες εταιρείες και συλλόγους του κλάδου
                          </li>
                          <li>
                            Η Β2Β επικοινωνία ανάμεσα σε εκθέτες με μεγάλα
                            τουριστικά γραφεία, tour operators, ξενοδοχειακές
                            μονάδες. εταιρείες VIP και εταιρείες Deals,
                            προκειμένου να διευρυνθεί ο κύκλος συνεργασιών όλων
                            των συμμετεχόντων.
                          </li>
                        </ol>
                      </p>
                      <br />
                      <p>
                        Για περισσότερες πληροφορίες επισκεφτείτε το site μας{" "}
                        <a
                          href="www.extremesportsexpo.gr"
                          target="_blank"
                          onMouseOver={changeColor}
                          onMouseOut={restoreColor}
                        >
                          www.extremesportsexpo.gr
                        </a>
                      </p>
                      <div style={{ marginTop: 100, marginBottom: 100 }}>
                        {/* xorigoi */}
                        <div>
                          <h3 style={{ color: "#7b838f", marginBottom: 30 }}>
                            ΧΟΡΗΓΟΙ ΤΗΣ ΕΚΘΕΣΗΣ
                          </h3>
                        </div>
                        <div class="container">
                          <div class="row">
                            <div class="col">
                              <a
                                href="https://www.eurodisc.gr/"
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <img
                                  src="assets/images/xtreme_sports_expo/xorigoi_eurodisc.png"
                                  alt="eurodisc-logo"
                                  style={sponsorStyle}
                                />
                              </a>
                            </div>
                            <div class="col">
                              <a
                                href="https://www.phoenixproductions.gr/"
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <img
                                  src="assets/images/xtreme_sports_expo/xorigoi_phoenix.png"
                                  alt="phoenix-logo"
                                  style={sponsorStyle}
                                />
                              </a>
                            </div>
                            <div class="col">
                              <a
                                href="https://www.pizzafan.gr/el"
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <img
                                  src="assets/images/xtreme_sports_expo/xorigoi_pizza_fan.png"
                                  alt="pizza-fan-logo"
                                  style={sponsorStyle}
                                />
                              </a>
                            </div>
                            <div class="col">
                              <a
                                href="https://speedforce.gr"
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <img
                                  src="assets/images/xtreme_sports_expo/xorigoi_speedforce.png"
                                  alt="speedforce-logo"
                                  style={sponsorStyle}
                                />
                              </a>
                            </div>
                            <div class="col">
                              <a
                                href="http://www.stepcom.gr/"
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <img
                                  src="assets/images/xtreme_sports_expo/xorigoi_stepcom1.png"
                                  alt="stepcom-logo"
                                  style={sponsorStyle}
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Extremeevent;



// WEBPACK FOOTER //
// ./src/components/extremeevent.js